module.exports = __webpack_public_path__ + "static/media/highlightedContentIcon.53256a8f.svg";